module.exports = __webpack_public_path__ + "static/img/13.7da306f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/13.png
// module id = YZWm
// module chunks = 0